module.exports = __webpack_public_path__ + "static/img/c2.68fd268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/c2.png
// module id = Hh8P
// module chunks = 16